import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/icon/icon-topic-label.png'
import _imports_1 from '@/assets/image/icon/nice.png'
import _imports_2 from '@/assets/image/icon/comment.png'


const _withScopeId = n => (_pushScopeId("data-v-58afe7b6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "talk-list-item-title" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "topic-label",
  src: _imports_0
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "为你推荐 · ", -1))
const _hoisted_4 = { class: "talk-list-item-main" }
const _hoisted_5 = { class: "l-box" }
const _hoisted_6 = { class: "talk-list-item-text" }
const _hoisted_7 = { class: "talk-list-item-footer" }
const _hoisted_8 = { class: "time" }
const _hoisted_9 = { class: "options" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_11 = { class: "count nice" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1))
const _hoisted_13 = { class: "count" }

import { ref, reactive, onMounted, watch } from 'vue'
import MImage from '@/components/MImage/MImage.vue'
import { getInnerTextContent } from '@/utils/common'


export default /*#__PURE__*/_defineComponent({
  __name: 'MWaterFall2',
  props: {
  listData: { type: Array },
},
  setup(__props) {

const props = __props;



const listRef = ref(null)
const waterfallItemRef = ref(null)
const state = reactive({
  waterfallArr: props.listData,
  array: [], //定义空数组存储元素高度
})

onMounted(() => {
  // setTimeout(() => {
  //   // 防止图片高度没有加载出来
  //   getWaterfall()
  // }, 100)
  // getWaterfall()
})

watch(
  () => props.listData,
  (newValue, oldValue) => {
    state.waterfallArr = newValue
    // state.array = []
    // setTimeout(() => {
    //   getWaterfall()
    // }, 100)
  }
)

const getWaterfall = () => {
  const columns = 2 //定义布局的列数为2
  const item = waterfallItemRef.value //获取每个子元素的DOM
  for (let i = 0; i < item.length; i++) {
    //遍历整个子元素的DOM集合
    if (i < columns) {
      //小于columns的子元素作为第一行
      item[i].style.top = 5 + 'px'
      item[i].style.left = item[0].clientWidth * i + 'px'
      if (i === 1) {
        item[i].style.left = item[i].offsetLeft + 5 + 'px'
      }
      state.array.push(item[i].clientHeight) //遍历结束时，数组array保存的是第一行子元素的元素高度
    } else {
      //大于等于columns的子元素将作其他行
      let minHeight = Math.min(...state.array) //  找到第一列的最小高度
      let index = state.array.findIndex((item) => item === minHeight) // 找到最小高度的索引
      //设置当前子元素项的位置
      item[i].style.top = state.array[index] + 5 + 'px'
      item[i].style.left = item[index].offsetLeft + 'px'
      //重新定义数组最小项的高度 进行累加
      state.array[index] += item[i].clientHeight
    }
  }
  listRef.value.style.height = Math.max(...state.array) + 'px' // 设置容器高度
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (state.waterfallArr.length)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        ref_key: "listRef",
        ref: listRef,
        class: "talk-list"
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.waterfallArr, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            key: item.id,
            ref_for: true,
            ref_key: "waterfallItemRef",
            ref: waterfallItemRef,
            class: "talk-list-item"
          }, [
            _createVNode(_component_router_link, {
              to: {
          path: `/talk-detail/${item.id}`,
          query: { detailType: 2, refresh: true },
        },
              class: "talk-list-item-bg"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  _createVNode(MImage, {
                    type: "avatar",
                    class: "avt",
                    src: item.headImg
                  }, null, 8, ["src"]),
                  _hoisted_2,
                  _hoisted_3,
                  _createElementVNode("span", null, _toDisplayString(item.topicType), 1)
                ]),
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, _toDisplayString(item.topicTitle), 1),
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, " 发布于 · " + _toDisplayString(item?.createDate ? item?.createDate.split(' ')[0] : ''), 1),
                      _createElementVNode("div", _hoisted_9, [
                        _hoisted_10,
                        _createElementVNode("div", _hoisted_11, _toDisplayString(item.likeCount), 1),
                        _hoisted_12,
                        _createElementVNode("div", _hoisted_13, _toDisplayString(item.commentCount), 1)
                      ])
                    ])
                  ]),
                  _createVNode(MImage, {
                    class: "talk-list-item-img",
                    src: item.coverImageUrl
                  }, null, 8, ["src"])
                ])
              ]),
              _: 2
            }, 1032, ["to"])
          ]))
        }), 128))
      ], 512))
    : _createCommentVNode("", true)
}
}

})